import {
  ContextualMenu,
  IDragOptions,
  IDropdownOption,
  Modal,
  PrimaryButton,
  Stack,
} from '@fluentui/react';
import {
  FormHookAmount,
  FormHookDropdown,
  FormHookTextField,
} from 'common/components/FormHooksFields';
import { ModalHeader } from '../../ModalHeader';
import { useStyles } from './index.styles';
import { FormHookCheckBox } from 'common/components/FormHooksFields/FormHookCheckBox';

export interface EditRuleModalProps {
  onClose: () => void;
  index: number;
  businessRuleCategoriesOptions: IDropdownOption<any>[];
  categoryOptionDisabled: boolean;
}
const DragOptions: IDragOptions = {
  moveMenuItemText: 'Move',
  closeMenuItemText: 'Close',
  menu: ContextualMenu,
  dragHandleSelector: '.ms-Modal-scrollableContent > div > div:first-child ',
};

export const EditRuleModal: React.FC<EditRuleModalProps> = ({
  onClose,
  businessRuleCategoriesOptions,
  index,
  categoryOptionDisabled,
}) => {
  const styles = useStyles();
  return (
    <Modal isOpen isBlocking dragOptions={DragOptions}>
      <Stack className={styles.container}>
        <ModalHeader onClose={onClose} title={'Edit Rule'} />
        <Stack
          tokens={{
            padding: 20,
            childrenGap: 20,
          }}
          className={styles.bodyContainer}
        >
          <FormHookTextField
            name={`rules.${index}.name`}
            label={'Description'}
            width={300}
          />
          <FormHookTextField
            name={`rules.${index}.columnHint`}
            label={'Hint'}
            width={300}
          />
          <FormHookAmount
            name={`rules.${index}.sortOrder`}
            label={'Sequence#'}
            width={300}
          />
          <FormHookDropdown
            name={`rules.${index}.configurationCategoryId`}
            label="Business Rule Category"
            options={businessRuleCategoriesOptions}
            disabled={categoryOptionDisabled}
            required
          />
          <Stack style={{ marginTop: 30 }}>
            <FormHookCheckBox
              label="Required"
              name={`rules.${index}.isRequired`}
            />
          </Stack>
        </Stack>
        <Stack tokens={{ childrenGap: 10 }} className={styles.footerStyle}>
          <PrimaryButton text={'Close'} onClick={onClose} />
        </Stack>
      </Stack>
    </Modal>
  );
};
